<template>
	<div class="chat-message-item">
		<div class="message-normal" :class="{ 'message-mine': mine }">
			<div class="head-image">
				<head-image :name="showName" :size="38" :url="headImage" :id="msgInfo.sendId"></head-image>
			</div>
			<div class="content">
				<div class="message-top">
					<span>{{ showName }}</span>
					<span>{{ $date.toTimeText(msgInfo.sendTime * 1000) }}</span>
				</div>
				<div class="message-bottom" @contextmenu.prevent="showRightMenu($event)">
					<div ref="chatMsgBox" class="message-content-wrapper">
						<!-- 文本 -->
						<span class="message-text" v-if="msgInfo.msgType == 1 || 
							msgInfo.msgType == 101 || msgInfo.msgType == 102" v-html="htmlText">
						</span>
						<!-- 图片 -->
						<div class="message-image" v-else-if="msgInfo.msgType == 2" @click="showFullImageBox()">
							<img :style="imageStyle" :src="data.sourcePath" loading="lazy" />
						</div>
						<!-- gif图 -->
						<div class="message-image" v-else-if="msgInfo.msgType == 3" @click="showFullImageBox()">
							<img :style="imageStyle" :src="data.url" loading="lazy" />
						</div>
						<!-- 文件 -->
						<div class="message-file" v-else-if="msgInfo.msgType == 4">
							<div class="chat-file-box" v-loading="sending">
								<div class="chat-file-info">
									<el-link class="chat-file-name" :underline="true" target="_blank" type="primary"
										:href="data.path" :download="data.name">{{ data.name}}</el-link>
									<div class="chat-file-size">{{ fileSize }}</div>
								</div>
								<div class="chat-file-icon">
									<span type="primary" class="el-icon-document"></span>
								</div>
							</div>
						</div>
						<!-- 视频 -->
						<div class="message-video" v-else-if="msgInfo.msgType == 5" @click="playVideo()">
							<div class="chat-video-box" v-loading="sending">
								<img v-if="data.snapshotUrl" class="chat-video-cover" :src="data.snapshotUrl" loading="lazy" />
								<div v-else class="chat-video-no-cover">
									<span class="el-icon-video-camera"></span>
								</div>
								<span class="chat-video-duration" v-if="data.duration > 0">{{ formatVideoDuration(data.duration) }}</span>
								<span class="chat-video-play el-icon-video-play"></span>
							</div>
						</div>
						<!-- 语音 -->
						<div class="message-voice-wrap" v-else-if="msgInfo.msgType == 6">
							<div class="message-voice" :title="data.text || '语音'" @click="onPlayVoice">
								<i class="voice-icon"
									:class="audioPlayState == 'RUNNING' ? 'el-icon-video-pause' : (audioPlayState == 'LOADING' ? 'el-icon-loading' : 'el-icon-microphone')"></i>
								<span class="voice-duration">{{ data.duration ? data.duration + '″' : '语音' }}</span>
							</div>
							<!-- 微信式转文字：语音下方展示转写内容，点击同样播放语音 -->
							<div class="voice-transcript" v-if="data.text" @click="onPlayVoice">{{ data.text }}</div>
						</div>
						<!-- 名片消息 -->
						<div class="message-card" v-else-if="msgInfo.msgType == 7">
							<div class="chat-card-box" v-loading="loading">
								<!-- 头像区域 -->
								<div class="chat-card-avatar">
									<el-avatar :size="50" :src="data.headImg" fit="cover"></el-avatar>
								</div>								
								<!-- 名片信息 -->
								<div class="chat-card-info">
									<div class="chat-card-name">
										{{ data.nickname }}
										<span v-if="data.title" class="chat-card-title">{{ data.title }}</span>
									</div>
									<div v-if="data.enterpriseName" class="chat-card-company">
										<span class="el-icon-office-building"></span>
										{{ data.enterpriseName }} - {{`名片` }}
									</div>
								</div>
							</div>
							<!-- 发送失败提示 (保持与文件消息一致) -->
							<span 
								title="发送失败" 
								v-show="loadFail" 
								@click="onSendFail"
								class="send-fail el-icon-warning">
							</span>
						</div>
						<!-- 小程序消息 -->
						<div class="message-micro" v-else-if="msgInfo.msgType == $enums.MESSAGE_TYPE.MICRO_PROGRAM">
							<div class="chat-micro-box" v-loading="loading">
								<!-- 小程序图标（https 下 http 图被拦截时回退占位图标） -->
								<img v-if="microIconSrc && !microIconBroken" class="chat-micro-icon" :src="microIconSrc" loading="lazy" @error="microIconBroken = true" />
								<div v-else class="chat-micro-icon chat-micro-icon-fallback">
									<span class="el-icon-cpu"></span>
								</div>
								<!-- 小程序信息 -->
								<div class="chat-micro-info">
									<div class="chat-micro-title" :title="data.title || ''">{{ data.title || '小程序' }}</div>
									<div class="chat-micro-desc" v-if="data.desc" :title="data.desc">{{ data.desc }}</div>
									<div class="chat-micro-app">{{ data.appName || '小程序' }}</div>
								</div>
							</div>
							<!-- 发送失败提示 -->
							<span title="发送失败" v-show="loadFail" @click="onSendFail" class="send-fail el-icon-warning">
							</span>
						</div>
						<!-- 链接消息 -->
						<div class="message-link" v-else-if="msgInfo.msgType == 10">
							<div class="chat-link-box" v-loading="loading">
								<!-- 链接图片预览 -->
								<div class="chat-link-image" v-if="data.headImg">
									<img :src="data.headImg" :alt="data.title" @click="openLink">
								</div>
								<!-- 链接信息 -->
								<div class="chat-link-info">
								<el-link class="chat-link-title" :underline="true" target="_blank" 
									type="primary" :href="data.url">
									{{ data.title || '无标题链接' }}
								</el-link>
								<!-- 链接描述 -->
								<div class="chat-link-desc" v-if="data.des">
									{{ data.des }}
								</div>
								<!-- 域名 -->
								<div class="chat-link-domain">
									<span class="el-icon-link"></span>
									{{ getDomain(data.url) }}
								</div>
								</div>
							</div>
							<!-- 发送失败提示 -->
							<span title="发送失败" v-show="loadFail" @click="onSendFail" class="send-fail el-icon-warning">
							</span>
						</div>
						<!-- 撤回/提示消息 -->
						<span class="message-tip-text" v-else-if="msgInfo.msgType == $enums.MESSAGE_TYPE.TIP_TEXT" style="text-align:center;color:#999;font-size:12px;display:block;padding:4px 0;">{{ msgInfo.content }}</span>
						<!-- 位置消息 -->
						<div class="message-location" v-else-if="msgInfo.msgType == $enums.MESSAGE_TYPE.LOCATION" @click="openLocationMap">
							<div class="chat-location-box">
								<div class="chat-location-icon">
									<span class="el-icon-location-outline"></span>
								</div>
								<div class="chat-location-info">
									<div class="chat-location-name">{{ data.address || '位置' }}</div>
									<div class="chat-location-address" v-if="data.detailedAddress">{{ data.detailedAddress }}</div>
								</div>
								<span class="el-icon-right chat-location-more"></span>
							</div>
						</div>
						<!-- 发送状态 -->
						<div title="发送中" v-if="sending" class="sending" v-loading="'true'"></div>
						<div title="发送失败" v-else-if="sendFail" @click="onSendFail" class="send-fail el-icon-warning"></div>
					</div>
					<!-- 消息已读未读 -->
					<div class="message-status" v-if="msgInfo.isWX">
						<span class="chat-readed" v-if="msgInfo.status == $enums.MESSAGE_STATUS.READED">已读</span>
						<span class="chat-unread" v-else>未读</span>
					</div>
				</div>
			</div>
		</div>
		<right-menu v-show="menu && rightMenu.show" :pos="rightMenu.pos" :items="menuItems"
			@close="rightMenu.show = false" @select="onSelectMenu"></right-menu>
		<!-- 视频播放弹层 -->
		<el-dialog title="视频" :visible.sync="videoPreviewVisible" width="70%" :append-to-body="true"
			@closed="onCloseVideoPreview">
			<video v-if="videoPreviewVisible" class="chat-video-player" :src="videoPreviewUrl" controls autoplay></video>
		</el-dialog>
	</div>
</template>

<script>
const _parsedCache = new WeakMap();
import HeadImage from "../common/HeadImage.vue";
import RightMenu from '../common/RightMenu.vue';
import { decode, isSilk } from '../../utils/silk/index.js';
export default {
	name: "messageItem",
	components: {
		HeadImage,
		RightMenu
	},
	props: {
		mode: {
			type: Number,
			default: 1
		},
		mine: {
			type: Boolean,
			required: true
		},
		headImage: {
			type: String,
			required: true
		},
		showName: {
			type: String,
			required: true
		},
		msgInfo: {
			type: Object,
			required: true
		},
		menu: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			audioPlayState: 'STOP',
			videoPreviewVisible: false, // 视频播放弹层是否显示
			videoPreviewUrl: '', // 视频播放地址
			microIconBroken: false, // 小程序图标加载失败（http 图/https 混合内容拦截）回退占位
			rightMenu: {
				show: false,
				pos: {
					x: 0,
					y: 0
				}
			}
		}
	},
	beforeDestroy() {
		// 销毁时停止播放并回收解码 blob URL
		if (this.audio) {
			this.audio.pause();
			this.audio.src = '';
		}
		if (this.voiceUrl) {
			URL.revokeObjectURL(this.voiceUrl);
		}
		// 若自己是全局播放者，清理引用避免后续互斥操作失效对象
		this.clearGlobalVoicePlayer();
	},
	methods: {
		onSendFail() {
			// 文本与语音消息支持自动重发（content 可直接复用），其他类型提示手动重发
			if (this.msgInfo.msgType == this.$enums.MESSAGE_TYPE.TEXT || this.msgInfo.msgType == this.$enums.MESSAGE_TYPE.VOICE) {
				this.$emit("resend", this.msgInfo);
			} else {
				this.$message.error("该消息不支持自动重新发送，建议手动重新发送")
			}
		},
		// 若自己是全局语音播放者则清理引用（window.__voicePlayer 全局互斥用）
		clearGlobalVoicePlayer() {
			if (window.__voicePlayer && window.__voicePlayer.vm === this) {
				window.__voicePlayer = null;
			}
		},
		// 停止本消息的语音播放（被其他语音抢占时调用）
		stopVoicePlayback() {
			if (this.audio) {
				this.audio.pause();
			}
			this.audioPlayState = 'STOP';
			this.clearGlobalVoicePlayer();
		},
		showFullImageBox() {
			let imageUrl = this.data.sourcePath;
			if (imageUrl) {
				this.$eventBus.$emit("openFullImage", imageUrl);
			}
		},
		// 播放视频：打开弹层播放（发送方存 path，接收方由后端补 path/videoPath）
		playVideo() {
			let videoUrl = this.data.path || this.data.videoPath || this.data.videoUrl;
			if (!videoUrl) {
				this.$message.warning('该视频暂无播放文件');
				return;
			}
			this.videoPreviewUrl = videoUrl;
			this.videoPreviewVisible = true;
		},
		onCloseVideoPreview() {
			this.videoPreviewUrl = '';
		},
		// 视频时长格式化：秒 → mm:ss
		formatVideoDuration(seconds) {
			seconds = parseInt(seconds) || 0;
			let m = Math.floor(seconds / 60);
			let s = seconds % 60;
			return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
		},
		onPlayVoice() {
			// 发送方存 soundPath，接收方由后端补 soundPath，兼容历史字段 url/sourceUrl
			let src = this.data.soundPath || this.data.url || this.data.sourceUrl;
			if (!src) {
				this.$message.warning('该语音暂无播放文件');
				return;
			}
			// 播放中再次点击则停止
			if (this.audioPlayState == 'RUNNING' && this.audio) {
				this.audio.pause();
				this.audioPlayState = 'STOP';
				this.clearGlobalVoicePlayer();
				return;
			}
			// 加载/解码中防抖，避免重复请求竞争 src
			if (this.audioPlayState == 'LOADING') {
				return;
			}
			if (!this.audio) {
				this.audio = new Audio();
				this.audio.onended = () => {
					this.audioPlayState = 'STOP';
					this.clearGlobalVoicePlayer();
				};
				this.audio.onerror = () => {
					this.audioPlayState = 'STOP';
					this.clearGlobalVoicePlayer();
					this.$message.error('语音播放失败');
				};
			}
			// 全局互斥：播放新语音前停止其他正在播放的语音
			if (window.__voicePlayer && window.__voicePlayer.vm !== this) {
				window.__voicePlayer.vm.stopVoicePlayback();
			}
			// 统一下载后按文件内容判断格式（扩展名不可靠）：
			// SILK 需解码为 wav 播放，其余格式（mp3 等）直接播放
			this.audioPlayState = 'LOADING';
			fetch(src).then((res) => {
				if (!res.ok) {
					throw new Error('语音文件加载失败(' + res.status + ')');
				}
				return res.arrayBuffer();
			}).then((buf) => {
				if (isSilk(buf)) {
					return decode(buf, 24000).then((wav) => {
						// 回收上一次解码产生的 blob URL
						if (this.voiceUrl) {
							URL.revokeObjectURL(this.voiceUrl);
						}
						this.voiceUrl = URL.createObjectURL(new Blob([wav.data], { type: 'audio/wav' }));
						return this.voiceUrl;
					});
				}
				return src;
			}).then((url) => {
				this.audio.src = url;
				this.audio.play();
				this.audioPlayState = 'RUNNING';
				// 播放成功后注册为全局播放者（供其他语音抢占时停止）
				window.__voicePlayer = { audio: this.audio, vm: this };
			}).catch((e) => {
				this.audioPlayState = 'STOP';
				this.clearGlobalVoicePlayer();
				this.$message.error('语音加载失败：' + (e && e.message ? e.message : e));
			});
		},
		showRightMenu(e) {
			this.rightMenu.pos = {
				x: e.x,
				y: e.y
			};
			this.rightMenu.show = "true";
		},
		onSelectMenu(item) {
			this.$emit(item.key.toLowerCase(), this.msgInfo);
		},
		openLink() {
    		window.open(this.data.url, '_blank', 'noopener,noreferrer');
  		},
		openLocationMap() {
			if (!this.data.longitude || !this.data.latitude) {
				return;
			}
			// 高德 URI 协议打开位置查看
			let params = [
				`position=${this.data.longitude},${this.data.latitude}`,
				`name=${encodeURIComponent(this.data.address || '位置')}`,
				`src=ocean-scrm&coordinate=gaode`
			].join('&');
			window.open(`https://uri.amap.com/marker?${params}`, '_blank', 'noopener,noreferrer');
  		},
		getDomain(url) {
    		// 提取域名显示
    		return url ? new URL(url).hostname.replace('www.', '') : '';
  		},
	},
	computed: {
		loading() {
			return this.msgInfo.loadStatus && this.msgInfo.loadStatus === "loading";
		},
		loadFail() {
			return this.msgInfo.loadStatus && this.msgInfo.loadStatus === "fail";
		},
		data() {
			const cached = _parsedCache.get(this.msgInfo);
			if (cached && cached.content === this.msgInfo.content) {
				return cached.parsed;
			}
			let parsed;
			try {
				parsed = JSON.parse(this.msgInfo.content);
			} catch (e) {
				parsed = {};
			}
			_parsedCache.set(this.msgInfo, { content: this.msgInfo.content, parsed });
			return parsed;
		},
		// 小程序封面 URL 清洗：协议回调/存量消息中参数分隔符可能为字面 \u0026（反斜杠+u0026），
		// 直用会被浏览器原样请求导致 mmbiz 返回 400 封面不显示，统一还原为 &
		microIconSrc() {
			return (this.data.weappIconUrl || '').replace(/\\u0026/g, '&');
		},
		sending() {
			return this.msgInfo.status == this.$enums.MESSAGE_STATUS.SENDING;
		},
		sendFail() {
			return this.msgInfo.status == this.$enums.MESSAGE_STATUS.FAILED;
		},
		fileSize() {
			let size = this.data.size;
			if (size > 1024 * 1024) {
				return Math.round(size / 1024 / 1024) + "M";
			}
			if (size > 1024) {
				return Math.round(size / 1024) + "KB";
			}
			return size + "B";
		},
		menuItems() {
			let items = [];
			// 小程序消息（已成功发送/收到的素材完整消息）支持转发到其他客户/群、收藏为快捷回复
			if (this.msgInfo.msgType == this.$enums.MESSAGE_TYPE.MICRO_PROGRAM &&
				this.msgInfo.status != this.$enums.MESSAGE_STATUS.FAILED) {
				items.push({
					key: 'FORWARD',
					name: '转发',
					icon: 'el-icon-share'
				});
				// 收藏为快捷回复：素材原样存入 quick_reply（也是自动回复小程序消息的素材来源）
				items.push({
					key: 'COLLECT',
					name: '设为快捷回复',
					icon: 'el-icon-star-off'
				});
			}
			items.push({
				key: 'DELETE',
				name: '删除',
				icon: 'el-icon-delete'
			});
			if (this.msgInfo.isWX && this.msgInfo.id > 0) {
				items.push({
					key: 'RECALL',
					name: '撤回',
					icon: 'el-icon-refresh-left'
				});
			}
			return items;
		},
		isTextMessage() {
			return this.msgInfo.msgType == this.$enums.MESSAGE_TYPE.TEXT
		},
		isAction() {
			return this.$msgType.isAction(this.msgInfo.msgType);
		},
		isNormal() {
			const type = this.msgInfo.msgType;
			return this.$msgType.isNormal(type) || this.$msgType.isAction(type)
		},
		htmlText() {
			let color = this.msgInfo.isWX ? 'white' : '';
			let text = this.$str.html2Escape(this.data.content)
			text = this.$url.replaceURLWithHTMLLinks(text, color)
			return this.$emo.transform(text, 'emoji-normal')
		},
		isGroupMessage() {
			return !!this.msgInfo.groupId;
		},
		imageStyle() {
			let maxSize = this.configStore.fullScreen ? 360 : 240;
			let minSize = 60;
			let width = this.data.width;
			let height = this.data.height;
			if (width && height) {
				let ratio = Math.min(width, height) / Math.max(width, height);
				let w = Math.max(Math.min(width > height ? maxSize : ratio * maxSize, width), minSize);
				let h = Math.max(Math.min(width > height ? ratio * maxSize : maxSize, height), minSize);
				return `width: ${w}px;height:${h}px;object-fit: cover;`
			} else {
				// 兼容历史版本，历史数据没有记录宽高
				return `max-width: ${maxSize}px;min-width:60px;max-height: ${maxSize}px;min-height:60px;`
			}
		}
	}
}
</script>

<style lang="scss">
.chat-message-item {
	padding: 3px 10px;
	border-radius: 10px;

	.message-tip {
		line-height: 50px;
		font-size: var(--im-font-size-small);
		color: var(--im-text-color-light);
	}

	.message-normal {
		position: relative;
		font-size: 0;
		padding-left: 48px;
		min-height: 50px;
		margin-top: 10px;

		.head-image {
			position: absolute;
			width: 40px;
			height: 40px;
			top: 0;
			left: 0;
		}

		.content {
			text-align: left;

			.message-top {
				display: flex;
				flex-wrap: nowrap;
				color: var(--im-text-color-light);
				font-size: var(--im-font-size);
				line-height: 20px;

				span {
					margin-right: 12px;
				}
			}

			.message-bottom {
				display: inline-block;
				padding-right: 300px;
				padding-left: 5px;


				.message-content-wrapper {
					position: relative;
					display: flex;
					align-items: flex-end;

					.sending {
						width: 25px;
						height: 25px;

						.circular {
							width: 25px;
							height: 25px;
						}
					}

					.send-fail {
						color: #e45050;
						font-size: 30px;
						cursor: pointer;
						margin: 0 5px;
					}
				}

				.message-text {
					flex: 1;
					display: inline-block;
					position: relative;
					line-height: 26px;
					padding: 6px 10px;
					background-color: var(--im-background);
					border-radius: 10px;
					font-size: var(--im-font-size);
					text-align: left;
					white-space: pre-wrap;
					word-break: break-word;

				}

				.message-image {
					border-radius: 8px;
					border: 2px solid var(--im-color-primary-light-9);
					overflow: hidden;
					cursor: pointer;
					background: var(--im-background);
				}

				.message-file {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					cursor: pointer;
					margin-bottom: 2px;
					background: var(--im-background);

					.chat-file-box {
						display: flex;
						flex-wrap: nowrap;
						align-items: center;
						min-height: 60px;
						box-shadow: var(--im-box-shadow-light);
						border-radius: 4px;
						padding: 10px 15px;

						.chat-file-info {
							flex: 1;
							height: 100%;
							text-align: left;
							font-size: 14px;
							margin-right: 10px;

							.chat-file-name {
								display: inline-block;
								min-width: 160px;
								max-width: 220px;
								font-size: 14px;
								margin-bottom: 4px;
								white-space: pre-wrap;
								word-break: break-all;
							}

							.chat-file-size {
								font-size: var(--im-font-size-smaller);
								color: var(--im-text-color-light);
							}
						}

						.chat-file-icon {
							font-size: 44px;
							color: #d42e07;
						}
					}

					.send-fail {
						color: #e60c0c;
						font-size: 30px;
						cursor: pointer;
						margin: 0 20px;
					}

				}

				// 视频消息
				.message-video {
					cursor: pointer;
					margin-bottom: 2px;

					.chat-video-box {
						position: relative;
						width: 200px;
						height: 140px;
						border-radius: 4px;
						overflow: hidden;
						box-shadow: var(--im-box-shadow-light);
						background: #000;

						.chat-video-cover {
							width: 100%;
							height: 100%;
							object-fit: cover;
							display: block;
						}

						.chat-video-no-cover {
							width: 100%;
							height: 100%;
							display: flex;
							align-items: center;
							justify-content: center;
							color: #fff;
							font-size: 48px;
						}

						.chat-video-duration {
							position: absolute;
							right: 6px;
							bottom: 6px;
							padding: 1px 6px;
							border-radius: 3px;
							background: rgba(0, 0, 0, 0.6);
							color: #fff;
							font-size: 12px;
							line-height: 18px;
						}

						.chat-video-play {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
							font-size: 44px;
							color: rgba(255, 255, 255, 0.9);
							text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
						}
					}
				}

				// 小程序消息
				.message-micro {
					position: relative;
					max-width: 300px;
					border-radius: 4px;
					overflow: hidden;
					box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

					.chat-micro-box {
						display: flex;
						align-items: flex-start;
						padding: 12px;
						background: #fff;
						border: 1px solid #ebeef5;

						.chat-micro-icon {
							width: 40px;
							height: 40px;
							flex-shrink: 0;
							margin-right: 12px;
							border-radius: 8px;
							object-fit: cover;
						}

						.chat-micro-icon-fallback {
							display: flex;
							align-items: center;
							justify-content: center;
							background: #f0f2f5;
							color: #909399;
							font-size: 22px;
						}

						.chat-micro-info {
							flex: 1;
							min-width: 0;

							.chat-micro-title {
								font-size: 15px;
								color: #303133;
								margin-bottom: 4px;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}

							.chat-micro-desc {
								font-size: 12px;
								color: #909399;
								margin-bottom: 4px;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 2;
								line-clamp: 2;
								overflow: hidden;
							}

							.chat-micro-app {
								font-size: 11px;
								color: #b0b3b8;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}
						}
					}

					.send-fail {
						color: #e60c0c;
						font-size: 30px;
						cursor: pointer;
						margin: 0 20px;
					}
				}

				// 名片消息
				.message-card {
					position: relative;
					max-width: 300px;
					border-radius: 4px;
					overflow: hidden;
					box-shadow: 0 1px 3px rgba(0,0,0,0.1);
					
					.chat-card-box {
						display: flex;
						padding: 12px;
						background: #fff;
						border: 1px solid #ebeef5;

						.chat-card-avatar {
							margin-right: 12px;
							flex-shrink: 0;
						}

						.chat-card-info {
							flex: 1;
							min-width: 0;

							.chat-card-name {
								font-size: 16px;
								font-weight: bold;
								margin-bottom: 6px;
								display: flex;
								align-items: center;
							}

							.chat-card-title {
								font-size: 12px;
								color: #666;
								margin-left: 8px;
								font-weight: normal;
							}

							.chat-card-company,
							.chat-card-phone {
								font-size: 13px;
								color: #666;
								margin-bottom: 4px;
								display: flex;
								align-items: center;
							
								.el-icon-office-building,
								.el-icon-phone {
									margin-right: 4px;
									color: #999;
								}
							}

							.chat-card-btn {
								margin-top: 8px;
								width: 100%;
							}
						}
					}

					.send-fail {
						/* 保持与文件消息相同样式 */
						position: absolute;
						right: -20px;
						top: 50%;
						transform: translateY(-50%);
						color: #f56c6c;
						cursor: pointer;
					}
				}

				// 链接消息
				.message-link {
					position: relative;
					max-width: 400px;
					border-radius: 4px;
					overflow: hidden;
					box-shadow: 0 1px 3px rgba(0,0,0,0.1);

					.chat-link-box {
						display: flex;
						background: #fff;
						border: 1px solid #ebeef5;

						.chat-link-image {
							width: 80px;
							height: 80px;
							overflow: hidden;
							flex-shrink: 0;
							cursor: pointer;

							img {
								width: 100%;
								height: 100%;
								object-fit: cover;
								transition: transform 0.3s;
								
								&:hover {
								transform: scale(1.05);
								}
							}
						}

						.chat-link-info {
							padding: 10px;
							flex: 1;
							min-width: 0;
						}

						.chat-link-title {
							font-size: 14px;
							font-weight: bold;
							display: block;
							margin-bottom: 6px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						.chat-link-desc {
							font-size: 12px;
							color: #666;
							margin-bottom: 6px;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							overflow: hidden;
						}

						.chat-link-domain {
							font-size: 12px;
							color: #999;
							display: flex;
							align-items: center;

							.el-icon-link {
								margin-right: 4px;
							}
						}
					}

					.send-fail {
						color: #e60c0c;
						font-size: 30px;
						cursor: pointer;
						margin: 0 20px;
					}
				}

				// 位置消息
				.message-location {
					position: relative;
					max-width: 300px;
					border-radius: 4px;
					overflow: hidden;
					cursor: pointer;
					box-shadow: 0 1px 3px rgba(0,0,0,0.1);

					.chat-location-box {
						display: flex;
						align-items: center;
						padding: 12px;
						background: #fff;
						border: 1px solid #ebeef5;

						.chat-location-icon {
							flex-shrink: 0;
							width: 36px;
							height: 36px;
							border-radius: 50%;
							background: #f0f7ff;
							display: flex;
							align-items: center;
							justify-content: center;
							margin-right: 10px;

							.el-icon-location-outline {
								font-size: 18px;
								color: #409eff;
							}
						}

						.chat-location-info {
							flex: 1;
							min-width: 0;

							.chat-location-name {
								font-size: 14px;
								font-weight: bold;
								color: #333;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}

							.chat-location-address {
								font-size: 12px;
								color: #999;
								margin-top: 4px;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}
						}

						.chat-location-more {
							flex-shrink: 0;
							margin-left: 8px;
							color: #c0c4cc;
							font-size: 14px;
						}
					}
				}

				.message-voice-wrap {
					.message-voice {
						display: flex;
						align-items: center;
						min-width: 90px;
						padding: 8px 12px;
						background-color: var(--im-background);
						border-radius: 10px;
						font-size: var(--im-font-size);
						cursor: pointer;
						user-select: none;

						.voice-icon {
							font-size: 18px;
							margin-right: 6px;
							color: var(--im-color-primary);
						}

						.voice-duration {
							line-height: 1;
						}
					}

					// 微信式语音转文字：语音下方独立文字块，点击同样播放语音
					.voice-transcript {
						margin-top: 6px;
						padding: 6px 10px;
						max-width: 260px;
						font-size: 13px;
						line-height: 1.5;
						color: #333;
						background-color: var(--im-background);
						border-radius: 8px;
						cursor: pointer;
						user-select: none;
						word-break: break-all;
					}
				}

				.chat-action {
					display: flex;
					align-items: center;

					.iconfont {
						cursor: pointer;
						font-size: 22px;
						padding-right: 8px;
					}
				}
				
				// 消息状态
				.message-status {
					margin-top: 3px;
					display: block;

					.chat-readed {
						font-size: 12px;
						// color: var(--im-text-color-light);
						color: var(--im-text-color-green);
					}

					.chat-unread {
						font-size: var(--im-font-size-smaller);
						color: var(--im-color-danger);
					}
				}

				.chat-receipt {
					font-size: var(--im-font-size-smaller);
					cursor: pointer;
					color: var(--im-text-color-light);
					
					.icon-ok {
						font-size: 20px;
						color: var(--im-color-sucess);
					}
				}

				.chat-at-user {
					padding: 2px 5px;
					border-radius: 3px;
					cursor: pointer;
				}
			}
		}


		&.message-mine {
			text-align: right;
			padding-left: 0;
			padding-right: 48px;

			.head-image {
				left: auto;
				right: 0;
			}

			.content {
				text-align: right;

				.message-top {
					flex-direction: row-reverse;

					span {
						margin-left: 12px;
						margin-right: 0;
					}
				}

				.message-bottom {
					padding-left: 180px;
					padding-right: 5px;

					.message-content-wrapper {
						flex-direction: row-reverse;
					}

					.message-text {
						background-color: var(--im-color-primary-light-2);
						color: #fff;
					}

					.chat-action {
						flex-direction: row-reverse;

						.iconfont {
							transform: rotateY(180deg);
						}
					}
				}
			}
		}

	}

	// 视频播放弹层（el-dialog append-to-body，全局选择器）
	.chat-video-player {
		width: 100%;
		max-height: 70vh;
		background: #000;
		border-radius: 4px;
		outline: none;
	}
}
</style>